import SignUpInput from "components/SignUpInput";
import config from "config";
import { SectionWrapper } from "pages/Product/styled";
import React from "react";
import styled from "styled-components/macro";
import { mediaMin } from "styles/media";

const Wrapper = styled(SectionWrapper)`
  position: relative;
  padding: 0;
  height: 426px;

  ${mediaMin.xs`
    height: 502px;
  `};

  ${mediaMin.md`
    height: 600px;
  `};

  ${mediaMin.lg`
    height: 700px;
  `};

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  overflow: hidden;
`;

const Title = styled.h1`
  margin: 0;
  line-height: 1.2;
  font-weight: 500;
  font-size: 28px;
  white-space: pre-line;
  text-align: center;

  ${mediaMin.xs`
    font-size: 44px;
  `};

  ${mediaMin.md`
    font-size: 56px;
  `};
`;

const Description = styled.p`
  margin: 24px 0;
  text-align: center;
  line-height: 1.4;
  font-size: 18px;

  &:before {
    content: "It's time to unleash your potential";
  }

  ${mediaMin.xs`
    font-size: 20px;
    &:before {
      content: "The best investment to unleash your potential";
    }
  `};
`;

const SignUpInputWrapper = styled.div`
  width: 100%;
`;

const LeftImageUrls = [
  `${config.RESOURCE_ORIGIN}/images/landing/product/outro/left-mobile.png`,
  `${config.RESOURCE_ORIGIN}/images/landing/product/outro/left-tablet.png`,
  `${config.RESOURCE_ORIGIN}/images/landing/product/outro/left-desktop.png`,
  `${config.RESOURCE_ORIGIN}/images/landing/product/outro/left-desktop-wide.png`,
];

const RightImageUrls = [
  `${config.RESOURCE_ORIGIN}/images/landing/product/outro/right-mobile.png`,
  `${config.RESOURCE_ORIGIN}/images/landing/product/outro/right-tablet.png`,
  `${config.RESOURCE_ORIGIN}/images/landing/product/outro/right-desktop.png`,
  `${config.RESOURCE_ORIGIN}/images/landing/product/outro/right-desktop-wide.png`,
];

const LeftImage = styled.div`
  position: absolute;
  object-fit: contain;
  background: center / contain no-repeat url(${LeftImageUrls[0]});
  width: 258px;
  height: 652px;
  left: -130px;

  ${mediaMin.xs`
    background: center / contain no-repeat url(${LeftImageUrls[1]});
    width: 480px;
    height: 890px;
    left: -160px;
    margin-top: 50px;
  `};

  ${mediaMin.md`
    background: center / contain no-repeat url(${LeftImageUrls[2]});
    width: 710px;
    height: 1110px;
    left: -300px;
    margin-top: 50px;
  `};

  ${mediaMin.lg`
    background: center / contain no-repeat url(${LeftImageUrls[3]});
    width: 924px;
    height: 1444px;
    left: 0;
    margin-left: -280px;
    margin-top: 60px;
  `};
`;

const RightImage = styled.div`
  position: absolute;
  object-fit: contain;
  background: center / contain no-repeat url(${RightImageUrls[0]});
  width: 312px;
  height: 644px;
  right: -150px;

  ${mediaMin.xs`
    background: center / contain no-repeat url(${RightImageUrls[1]});
    width: 518px;
    height: 810px;
    right: -220px;
    margin-top: 30px;
  `};

  ${mediaMin.md`
    background: center / contain no-repeat url(${RightImageUrls[2]});
    width: 694px;
    height: 1044px;
    right: -280px;
    margin-top: 30px;
  `};

  ${mediaMin.lg`
    background: center / contain no-repeat url(${RightImageUrls[3]});
    width: 904px;
    height: 1358px;
    right: 0;
    margin-right: -350px;
    margin-top: 70px;
  `};
`;

const ContentsWrapper = styled.div`
  z-index: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 0 16px;
`;

export function BottomSignUpSection() {
  return (
    <Wrapper>
      <LeftImage />
      <RightImage />
      <ContentsWrapper>
        <Title>
          The smartest assistant?
          {"\n"}Yess, I am.
        </Title>
        <Description />
        <SignUpInputWrapper>
          <SignUpInput formId="product-bottom-sign-up-form" />
        </SignUpInputWrapper>
      </ContentsWrapper>
    </Wrapper>
  );
}
